import request from "@/utils/request";

//获取服务公开列表
export function GetServiceList(params) {
  return request({
    url: "feedback/",
    method: "get",
    params
  });
}
// 获取服务公开反馈详情
export function GetServiceDetail(params) {
  return request({
    url: "feedback/show",
    method: "get",
    params
  });
}
//点赞
export function GetThumbUp(params) {
  return request({
    url: "feedback/thumb-up",
    method: "get",
    params
  });
}
//取消点赞
export function DelThumbUp(params) {
  return request({
    url: "feedback/cancel-thumb-up",
    method: "get",
    params
  });
}
//是否点赞
export function HasVoted(params) {
  return request({
    url: "feedback/check-voted",
    method: "get",
    params
  });
}

// WEBPACK FOOTER //
// ./src/api/ServicePublic.js



// WEBPACK FOOTER //
// ./src/api/ServicePublic.js